import React, { memo, useEffect, useRef, useState } from "react";
import LoginModal from "../modals/loginModal";
import RegistrationModal from "../modals/registrationModal";
import LoginTypeModal from "../modals/loginTypeModal";
import { useDispatch, useSelector } from "react-redux";
import { clearUser } from "../../../../store/reducers/userSlice";

import {
  logOut,
  setIsLoginTypeModal,
} from "../../../../store/reducers/authSlice";
import { useTranslation } from "react-i18next";
import ChooseRoleModal from "../modals/ChooseRoleModal";
import { Link, useNavigate } from "react-router-dom";
import MIcon from "../../../common/m-icon/MIcon";
import { useLogoutMutation } from "../../../../api/AuthApi/authService";

function AuthPanel({ role, isOpen, setIsOpen }) {
  const dispatch = useDispatch();

  const [isLoginModal, setIsLoginModal] = useState(false);
  const [isRegistrationModal, setIsRegistrationModal] = useState(false);
  const [isChooseRoleModal, setIsChooseRoleModal] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const menuRef = useRef(null);
  const user = useSelector((state) => state.user);
  const storedUser = JSON.parse(localStorage.getItem("user")) || {};
  const isAuth = useSelector((state) => state.auth.isAuth);
  const isTypeModal = useSelector((state) => state.auth.isLoginTypeModal);
  const token = useSelector((state) => state.auth.token);
  const [logout] = useLogoutMutation();

  const navigate = useNavigate();

  const handleClick = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setIsClicked(false);
    }
  };

  const { t } = useTranslation();

  useEffect(() => {
    if (user?.lastname || user?.firstname) {
      localStorage.setItem("user", JSON.stringify(user));
    }
  }, [user]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick); // ✅ чистим listener
  }, []);

  const displayName = user?.lastname
    ? `${user.lastname} ${user.firstname}`
    : storedUser?.lastname
    ? `${storedUser.lastname} ${storedUser.firstname}`
    : "";

  return (
    <>
      {isAuth ? (
        <div className={"flex relative"}>
          <div className="flex flex-row items-center">
            <div className="flex items-center mr-2">
              <MIcon
                type={"userCircle"}
                className={`${
                  !isOpen ? "text-white" : "text-main-color"
                } cursor-pointer`}
              />
            </div>
            <div className="flex flex-col">
              <div
                className={`text-sm ${
                  !isOpen ? "text-white" : "text-main-color"
                }`}
              >
                {displayName}
              </div>
              <div
                className={`text-xs ${
                  !isOpen ? "text-white" : "text-main-color"
                }`}
              >
                {t(`general.models.auth.roleType.${role}`)}
              </div>
            </div>
            <div
              className="flex items-center ml-2 hover:cursor-pointer"
              onMouseDown={(e) => {
                e.stopPropagation();
                setIsClicked((prev) => !prev);
              }}
            >
              {isClicked ? (
                <MIcon
                  type={"arrowDown"}
                  className={`${
                    isOpen ? "text-blue3" : "text-white"
                  } rotate-180`}
                />
              ) : (
                <MIcon
                  type={"arrowDown"}
                  className={`${isOpen ? "text-blue3" : "text-white"}`}
                />
              )}
            </div>
          </div>
          <div
            className={`${isClicked ? "" : "hidden"} bg-${
              user?.activeRole || "gray"
            } p-3 right-0 rounded-lg absolute text-white ${
              isOpen ? "top-[58px]" : "top-[52px]"
            } z-40`}
            ref={menuRef}
          >
            <p className="my-1 hover:cursor-pointer">
              <Link
                onClick={() => {
                  setIsOpen(false);
                  setIsClicked(false);
                }}
                className={"whitespace-nowrap"}
                to="/settings"
              >
                {t("general.header.settings")}
              </Link>
            </p>

            <p className="my-1 hover:cursor-pointer">
              <Link
                onClick={() => {
                  setIsOpen(false);
                  setIsClicked(false);
                }}
                className={"whitespace-nowrap"}
                to="/change-password"
              >
                {t("general.header.changePassword")}
              </Link>
            </p>

            {user?.roles?.length > 1 && (
              <p
                className="my-1 hover:cursor-pointer"
                onClick={() => {
                  setIsChooseRoleModal((prev) => !prev);
                  setIsOpen(false);
                  setIsClicked(false);
                }}
              >
                {t("general.header.role")}
              </p>
            )}

            <p
              className="my-1 hover:cursor-pointer"
              onClick={async () => {
                setIsClicked(false);
                await logout({ access_token: token });
                dispatch(logOut());
                dispatch(clearUser());
                localStorage.removeItem("user");
                localStorage.removeItem("last_login");
                navigate("/");
              }}
            >
              {t("general.header.exit")}
            </p>
          </div>
          <ChooseRoleModal
            isChooseRoleModal={isChooseRoleModal}
            setIsChooseRoleModal={setIsChooseRoleModal}
          />
        </div>
      ) : (
        <>
          <button
            className="btn-secondary"
            onClick={() => {
              setIsRegistrationModal(true);
              setIsOpen(false);
            }}
          >
            {t("general.header.register")}
          </button>

          <button
            className="btn-primary mr-2 flex gap-2 items-center h-[48px]"
            onClick={() => {
              dispatch(setIsLoginTypeModal(true));
              setIsOpen(false);
            }}
          >
            <MIcon type="userCircle" />
            {t("general.header.logIn")}
          </button>

          <LoginModal
            isLoginModal={isLoginModal}
            setIsLoginModal={setIsLoginModal}
            setIsClicked={setIsClicked}
          />

          <RegistrationModal
            isRegistrationModal={isRegistrationModal}
            setIsRegistrationModal={setIsRegistrationModal}
            setIsClicked={setIsClicked}
          />

          <LoginTypeModal
            isTypeModal={isTypeModal}
            setIsLoginModal={setIsLoginModal}
          />
        </>
      )}
      <ChooseRoleModal
        isChooseRoleModal={isChooseRoleModal}
        setIsChooseRoleModal={setIsChooseRoleModal}
        isAuth={isAuth}
      />
    </>
  );
}

export default memo(AuthPanel);
